export const CREATE_PROJECT_START = 'CREATE_PROJECT_START';
export const CREATE_PROJECT_FAILED = 'CREATE_PROJECT_FAILED';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
